import React from "react";
import { Box, Typography } from "@mui/material";

export const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{padding: '24px 0px'}}>
                    {children}
                </Box>
            )}
        </div>
    );
};

export type TabPanelProps = {
    index: number;
    value: number;
    children?: React.ReactNode;
};
